/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { InstallerTokensPage } from '@/pages/InstallerTokens/InstallerTokensPage';

export function InstallerTokenRoute() {
  return <InstallerTokensPage />;
}
